import { HOY } from '../data/db.js';

/* ---------- Utilidades ---------- */
export const eur  = n => new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR',maximumFractionDigits:2,useGrouping:true}).format(n||0);
export const eurK = n => Math.abs(n)>=1000 ? new Intl.NumberFormat('es-ES',{maximumFractionDigits:0,useGrouping:true}).format(n)+' €' : eur(n);
export const num  = (n,d=2) => new Intl.NumberFormat('es-ES',{minimumFractionDigits:d,maximumFractionDigits:d}).format(n||0);
export const cant = n => num(n, n>=1000?0:2);
export const fecha = f => f ? new Date(f+'T00:00:00').toLocaleDateString('es-ES',{day:'2-digit',month:'short',year:'numeric'}) : '—';
export const fechaCorta = f => f ? new Date(f+'T00:00:00').toLocaleDateString('es-ES',{day:'2-digit',month:'2-digit',year:'2-digit'}) : '—';
export const dias = f => Math.round((new Date(f+'T00:00:00') - HOY)/86400000);
export const hoyISO = () => HOY.toISOString().slice(0,10);
export const anioActual = HOY.getFullYear();
export const MEDIDAS = ['ud','m','m²','m³','km','h','t','kg','l','%','jornada'];
export const esc = s => String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
export const peso = b => b>=1048576 ? num(b/1048576,1)+' MB' : Math.round(b/1024)+' KB';
export const MESES = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
export const cap = s => s.charAt(0).toUpperCase()+s.slice(1);
export const val = id => (document.getElementById(id)?.value ?? '').trim();
/* Quita acentos y pasa a minúsculas para comparar texto sin sustos, sin
   tocar espacios ni el resto de la puntuación (para poder buscar por
   varias palabras). */
const RE_ACENTOS = new RegExp('['+String.fromCharCode(0x0300)+'-'+String.fromCharCode(0x036f)+']','g');
export const normaliza = s => String(s??'').toLowerCase().normalize('NFD').replace(RE_ACENTOS,'');
